const React = require("react")
const { IncidentManager } = require("./icons/incident-manager")
const { Negotiation } = require("./icons/negotiation")
const { Tickets } = require("./icons/tickets")
const { InterfaceOnline } = require("./icons/interface-online")

module.exports = {
  IncidentManager: (props) => (
    <IncidentManager alt="Meus protocolos" {...props} />
  ),
  Negotiation: (props) => <Negotiation alt="Negociar faturas" {...props} />,
  Tickets: (props) => <Tickets alt="Suporte técnico" {...props} />,
  InterfaceOnline: (props) => (
    <InterfaceOnline alt="Suporte técnico" {...props} />
  )
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/cardButton/index.js